interface NounsVarietyAndNumber {
  number: number;
  noun: string;
  nounPlural: string;
  nounFirst: string;
}

export default function getNounVarietyByNumber(data: NounsVarietyAndNumber) {
  const { number } = data;
  const lastDigit = number.toString().slice(-1);

  if (number === 1) {
    return data.nounFirst;
  } else if (
    (number > 20 || number < 10) &&
    (lastDigit === '2' || lastDigit === '3' || lastDigit === '4')
  ) {
    return data.nounPlural;
  }

  return data.noun;
}
